import { isObject } from 'lodash-es'

export const multipleChoicesSchemaHandle = {
  handle (node, { pageType }) {
    const {choiceValues, props, uiComponent} = node
    return {
      props: {
        ...props,
        options: choiceValues.map(item => {
          return {
            choiceKey: item.choiceValue.choiceKey,
            value: item.choiceValue.value,
            state: item.state
          }
        }),
        uiComponent: pageType === 'list' ? 1 : uiComponent
      }
    }
  }
}

export const multipleChoicesProps = {
  showTooltip: {
    type: Boolean,
    default: true
  },
  value: {
    type: [Array, String],
    default: () => []
  },
  // title
  name: {
    type: String,
    default: ''
  },
  // 多选样式
  uiComponent: {
    type: Number,
    default: 1
  },
  // 多选样式为radio时是横排还是竖排
  selectedShowStyle: {
    type: Number,
    default: 1
  },
  // 未选择时的展示文案
  placeholder: {
    type: String,
    default: '请选择'
  },
  // 是否只读
  disabled: {
    type: Boolean,
    default: false
  },
  // 数据源
  options: {
    type: Array,
    default: () => {
      return [
        {
          choiceValue: {
            choiceKey: 'multi_select_pull_A',
            value: 'multi_select_pull_A'
          },
          common: 2,
          defaultChoice: false,
          delete: null,
          isDefaultChoice: false,
          isDelete: null,
          region: 2,
          sortNum: 1,
          state: 0
        },
        {
          choiceValue: {
            choiceKey: 'multi_select_pull_B',
            value: 'multi_select_pull_B'
          },
          common: 2,
          defaultChoice: false,
          delete: null,
          isDefaultChoice: false,
          isDelete: null,
          region: 2,
          sortNum: 2,
          state: 0
        }
      ]
    }
  },
  // 纯文本
  isPureText: {
    type: Boolean,
    default: true
  },
  // 组件大小
  size: {
    type: String,
    default: 'small'
  }
}

const getLabelByFieldOptions = (value, field) => {
  const { options } = field
  if (value && value.length && !isObject(value[0])) {
    return value.map(v => {
      const find = options.find(j => j.choiceKey === v) || {}
      return {
        value: find.value || '',
        key: find.choiceKey || ''
      }
    })
  }
  return value || []
}

function cb (value, field) {
  let valSet = []
  const multValue = getLabelByFieldOptions(value, field)
  multValue.forEach(({value}) => {
    value && valSet.push(value)
  })
  return valSet.join(',')
}

export function initValue (value, field) {
  return value.length === 0 ? '-' : cb(value, field)
}